import React, { Component } from 'react';
import { Layout } from 'antd';
import Drawer from '../components/drawer';
import NavigationHeader from '../components/header';

const { Content, Footer } = Layout;

export class NavigationLayout extends Component {
	state = {
		collapsed: window.innerWidth < 1024
	};

	handleOnCollapse = () => {
		this.setState(prevState => ({
			collapsed: !prevState.collapsed
		}));
	};
	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize = () => {
		this.setState({
			// windowWidth: window.innerWidth
		});
	};
	disableScroll = () => {
		document.body.classList.add('overflow-hide');
		document.body.classList.remove('overflow-show');
	};

	enableScroll = () => {
		document.body.classList.add('overflow-show');
		document.body.classList.remove('overflow-hide');
	};

	render() {
		const { location, history } = this.props.children.props;

		return (
			<Layout style={{ minHeight: '100vh', overflow: window.innerWidth < 600 ? 'hidden' : '' }}>
				<Layout>
					<NavigationHeader location={location} history={history} collapsed={this.state.collapsed} handleOnCollapse={() => this.handleOnCollapse()} />
					<Content
						onClick={() => {
							if (!this.state.collapsed && window.innerWidth < 600) {
								this.setState({ collapsed: true });
							}
						}}
					>
						{this.props.children}
					</Content>
					<Footer style={{ textAlign: 'center' }}>Copyright &copy; The Hong Kong University of Science and Technology. All rights reserved.</Footer>
				</Layout>
			</Layout>
		);
	}
}

export default NavigationLayout;
